import BaseService from 'services/BaseService';
import DataHelpers from 'helpers/DataHelpers';

//-------------------------------------------------------------------------------------------------------------------

export default class TodoService
    extends BaseService {

    static types = [
        'ApproveAmendments',
        'Booking',
        'Custom'
    ];

    static getTypeName(type) {
        switch (type) {
            case 'ApproveAmendments': return 'Approve availablity amendments';
        }
        return type;
    }

    static async list(param) {
        if (param != null) {
            param = { ...param };
            param.types = DataHelpers.convertIDList(param.types);
        }
        return BaseService.callAPI('todo/list', param);
    }

    static async excel(param) {
        return BaseService.callAPI('todo/list-excel', {
            ...param,
            isDownload: true,
            fileName: 'Todos.xlsx'
        });
    }

    static async get(id) {
        return BaseService.callAPI('todo/get/' + id);
    }

    static async save(todo) {
        return BaseService.callAPI('todo/save', todo);
    }

    static async delete(id) {
        return BaseService.callAPI('todo/delete/' + id);
    }

    static async getComment(id) {
        return BaseService.callAPI('todo/get-comment/' + id);
    }

    static async saveComment(comment) {
        return BaseService.callAPI('todo/save-comment', comment);
    }

    static async deleteComment(id) {
        return BaseService.callAPI('todo/delete-comment/' + id);
    }
}
